<template>
  <div class="stairs">
      <template v-for="(item, index) in 61">
          <img v-show="Index%61==index" :src="require('../../assets/images/stairs/'+index+'.png')" :key="index" alt="">
      </template>
  </div>
</template>

<script>
export default {
  components:{},
  props:['Index'],
  data(){
    return {
        
    }
  },
  watch:{},
  computed:{},
  methods:{},
  created(){
      
  },
  mounted(){}
}
</script>
<style scoped>
.stairs{
  position: absolute;
  top: 5.3rem;
  left: 0rem;
  width: 4rem;
  height: 7.5rem;
  z-index: 49;
}
.stairs img{
    width: 100%;
    height: 100%;
}
</style>